/**
 * @generated SignedSource<<2faf0df79a2741ed57baebca1d909da4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type dependencies_usePrefectureLinksQuery$variables = {
  choice: string
}
export type dependencies_usePrefectureLinksQuery$data = {
  readonly countCemeteries: {
    readonly countsByPrefecture: ReadonlyArray<{
      readonly count: number
      readonly roma: string
    }>
  }
}
export type dependencies_usePrefectureLinksQuery = {
  variables: dependencies_usePrefectureLinksQuery$variables
  response: dependencies_usePrefectureLinksQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'choice'
      }
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                items: [
                  {
                    kind: 'Variable',
                    name: 'choices.0',
                    variableName: 'choice'
                  }
                ],
                kind: 'ListValue',
                name: 'choices'
              }
            ],
            kind: 'ObjectValue',
            name: 'filter'
          }
        ],
        concreteType: 'CemeteryCounts',
        kind: 'LinkedField',
        name: 'countCemeteries',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'CountWithRoma',
            kind: 'LinkedField',
            name: 'countsByPrefecture',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'count',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'roma',
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'dependencies_usePrefectureLinksQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'dependencies_usePrefectureLinksQuery',
      selections: v1 /*: any*/
    },
    params: {
      cacheID: 'eaecd2b0bc347ac8c1368237dcadfe79',
      id: null,
      metadata: {},
      name: 'dependencies_usePrefectureLinksQuery',
      operationKind: 'query',
      text: 'query dependencies_usePrefectureLinksQuery(\n  $choice: String!\n) {\n  countCemeteries(filter: {choices: [$choice]}) {\n    countsByPrefecture {\n      count\n      roma\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = 'b5abf71514e2e8800e2dbd888c1512fa'

export default node
